interface Config {
  mode: string
  restApiUrl: string
  calendarApiUrl: string
  voiceAiApiUrl: string
  baseUrl: string
  bucketUrl: string
}

const config: { [key: string]: Config } = {
  staging: {
    mode: 'staging',
    restApiUrl: 'https://staging.backend.leadconnectorhq.com',
    calendarApiUrl: 'https://staging.backend.leadconnectorhq.com',
    voiceAiApiUrl: 'https://staging.services.leadconnectorhq.com/voice-ai',
    baseUrl: 'https://staging.backend.leadconnectorhq.com/appengine',
  },
  interop: {
    mode: 'interop',
    restApiUrl: 'https://interop.backend.leadconnectorhq.com',
    calendarApiUrl: 'https://interop.backend.leadconnectorhq.com',
    voiceAiApiUrl: 'https://interop.services.leadconnectorhq.com/voice-ai',
    baseUrl: 'https://staging.backend.leadconnectorhq.com/appengine',
  },
  beta: {
    mode: 'beta',
    restApiUrl: 'https://backend.leadconnectorhq.com',
    calendarApiUrl: 'https://backend.leadconnectorhq.com',
    voiceAiApiUrl: 'https://services.leadconnectorhq.com/voice-ai',
    baseUrl: 'https://backend.leadconnectorhq.com/appengine',
  },
  production: {
    mode: 'production',
    restApiUrl: 'https://backend.leadconnectorhq.com',
    calendarApiUrl: 'https://backend.leadconnectorhq.com',
    voiceAiApiUrl: 'https://services.leadconnectorhq.com/voice-ai',
    baseUrl: 'https://backend.leadconnectorhq.com/appengine',
  },
}

const env =
  process.env.NODE_ENV === 'production'
    ? 'production'
    : process.env.NODE_ENV === 'beta'
      ? 'beta'
      : process.env.NODE_ENV === 'interop'
        ? 'interop'
        : 'staging'

const envConfig = config[env]
envConfig.bucketUrl = `https://storage.googleapis.com/${env === 'production'
  ? 'preview-production-assets/calendars/img'
  : env === 'interop'
    ? 'automation-calendars-staging/assets/img'
    : 'automation-calendars-staging/assets/img'
  }`
export default envConfig
